export default "__VITE_ASSET__CBl_ITEJ__"